/**
 * Payment integration model
 * Maps to QPilotPaymentIntegration from old QMC
 * See: qpilot-merchant-center/src/app/qpilot-payment-integration.ts
 */
export interface PaymentIntegration {
  Id: number;
  SiteId: number;
  PaymentMethodType: string; // 'Stripe', 'AuthorizeNet', 'Braintree', etc.
  ApiAccount: string;
  ApiKey1: string;
  ApiKey2: string;
  ApiKey3: string;
  TestMode: boolean;
  AuthorizeOnly: boolean;
  GatewayPaymentType: string;
  CreatedUtc: Date;
  UpdatedUtc: Date;
}

/**
 * Payment method type enum
 * Maps to QPilotPaymentMethodType from old QMC
 */
export enum PaymentMethodType {
  Stripe = "Stripe",
  AuthorizeNet = "AuthorizeNet",
  Test = "Test",
  PayPal = "PayPal",
  PaypalV2 = "PaypalV2",
  Braintree = "Braintree",
  Undefined = "Undefined",
  Other = "Other",
  Shopify = "Shopify",
  Airwallex = "Airwallex",
}

/**
 * Gateway payment type options (for Stripe)
 */
export const STRIPE_GATEWAY_PAYMENT_TYPES = [
  { code: "0", name: "Automated Clearing Settlement System" },
  { code: "1", name: "Afterpay / Clearpay" },
  { code: "2", name: "Alipay" },
  { code: "3", name: "BECS Direct Debit" },
  { code: "4", name: "Bacs Direct Debit" },
  { code: "5", name: "Bancontact" },
  { code: "6", name: "Boleto" },
  { code: "7", name: "Card" },
  { code: "8", name: "Stripe Terminal" },
  { code: "9", name: "Cash Balance" },
  { code: "10", name: "Eps" },
  { code: "11", name: "Fpx" },
  { code: "12", name: "Giropay" },
  { code: "13", name: "Grabpay" },
  { code: "14", name: "Ideal" },
  { code: "15", name: "Interac debit cards" },
  { code: "16", name: "Klarna" },
  { code: "17", name: "Konbini" },
  { code: "18", name: "Oxxo" },
  { code: "19", name: "Przelewy24" },
  { code: "20", name: "Paynow" },
  { code: "21", name: "SEPA Direct Debit" },
  { code: "22", name: "Sofort" },
  { code: "23", name: "ACH Direct Debit" },
  { code: "24", name: "WeChat Pay" },
  { code: "32", name: "Link" },
] as const;

/**
 * PayPal gateway payment type options
 */
export const PAYPAL_GATEWAY_PAYMENT_TYPES = [
  { code: "25", name: "paypal_FUNDING_PAYPAL" },
  { code: "26", name: "paypal_FUNDING_CARD" },
  { code: "27", name: "paypal_FUNDING_PAYLATER" },
  { code: "28", name: "paypal_FUNDING_CREDIT" },
  { code: "29", name: "paypal_FUNDING_VENMO" },
] as const;
